module.exports = __webpack_public_path__ + "assets/img/32_526_big.801d596d.jpg";